module.exports = __webpack_public_path__ + "img/92478f6.svg";